import React from 'react';
import OpCodeBuilder from 'builders/builderOpcode/configMode/index';

export default function OpCodes({
    defaultTab = 'classic'
}) {
    return (
        <>
            <OpCodeBuilder defaultTab={defaultTab} />
        </>
    );
}